export var fonts = {
  primary: 'Poppins, system-ui, sans-serif'
};
//# sourceMappingURL=fonts.js.map